import { Route } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { ProtectedRoute } from '@/components/routing';

// Lazy load learner pages
const Dashboard = lazy(() => import('@/pages/Dashboard'));
const Profile = lazy(() => import('@/pages/Profile'));
const MyFormations = lazy(() => import('@/pages/MyFormations'));
const Certificates = lazy(() => import('@/pages/Certificates'));
const ProgressPage = lazy(() => import('@/pages/ProgressPage'));
const DocumentsPage = lazy(() => import('@/pages/Documents'));
const BillingPage = lazy(() => import('@/pages/BillingPage'));
const SupportPage = lazy(() => import('@/pages/SupportPage'));
const QuizHistory = lazy(() => import('@/pages/QuizHistory'));
const CoursePage = lazy(() => import('@/pages/CoursePage'));
const MesDocuments = lazy(() => import('@/pages/MesDocuments'));

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    Chargement...
  </div>
);

export function LearnerRoutes() {
  return (
    <>
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute>
            <Suspense fallback={<PageLoader />}>
              <Dashboard />
            </Suspense>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/profile" 
        element={
          <ProtectedRoute>
            <Suspense fallback={<PageLoader />}>
              <Profile />
            </Suspense>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/my-formations" 
        element={
          <ProtectedRoute>
            <Suspense fallback={<PageLoader />}>
              <MyFormations />
            </Suspense>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/certificates" 
        element={
          <ProtectedRoute>
            <Suspense fallback={<PageLoader />}>
              <Certificates />
            </Suspense>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/progress" 
        element={
          <ProtectedRoute>
            <Suspense fallback={<PageLoader />}>
              <ProgressPage />
            </Suspense>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/documents" 
        element={
          <ProtectedRoute>
            <Suspense fallback={<PageLoader />}>
              <DocumentsPage />
            </Suspense>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/billing" 
        element={
          <ProtectedRoute>
            <Suspense fallback={<PageLoader />}>
              <BillingPage />
            </Suspense>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/support" 
        element={
          <ProtectedRoute>
            <Suspense fallback={<PageLoader />}>
              <SupportPage />
            </Suspense>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/quiz-history" 
        element={
          <ProtectedRoute>
            <Suspense fallback={<PageLoader />}>
              <QuizHistory />
            </Suspense>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/mes-documents" 
        element={
          <ProtectedRoute>
            <Suspense fallback={<PageLoader />}>
              <MesDocuments />
            </Suspense>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/course/:id" 
        element={
          <Suspense fallback={<PageLoader />}>
            <CoursePage />
          </Suspense>
        } 
      />
    </>
  );
}
